import React from 'react'
import { useParams } from 'react-router'
import { useState, useEffect,useRef } from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet';
import Images from './images'
import Button from '../../forms/blackfillButton'
import ProductGrid7 from '../pages/home/productGrid7'
import { ReactComponent as BookmarkIcon} from '../../../images/icons/Bookmark.svg'
import { ReactComponent as BookmarkFillIcon} from '../../../images/icons/Bookmark_Active.svg'
import { ReactComponent as LikeIcon} from '../../../images/icons/like.svg'
import { ReactComponent as LikeFillIcon} from '../../../images/icons/Liked.svg'
import { ReactComponent as MessageChatIcon} from '../../../images/icons/MessageChat.svg'
import { ReactComponent as ShareIcon} from '../../../images/icons/share.svg'
import DiscountIcon from '../../../images/icons/discount.png'
import '../../../css/components/public/product.css'
import CommentBox from '../../others/comments'
import ApiUrl from '../../../configTools/apiUrl'
import SharePopup from '../others/sharePopup'
import ProductGrid8 from '../pages/home/productGrid8'
import ProductUser from './user';
import ChatFunctions from '../../../functions/public/chat'
import DocumentMeta from 'react-document-meta';

const Index = ({setOpenChatBox}) => {
    const Bag = JSON.parse(localStorage.getItem("product-cart"));
    const ChatBoxes = JSON.parse(localStorage.getItem("chat-boxes"));
    const popupBox = useRef(null);
    const popupBoxContainer = useRef(null);
    const [User,setUser] = useState(JSON.parse(localStorage.getItem("user-info")));
    const [rcProduct,setRcProduct] = useState(JSON.parse(localStorage.getItem("rcnsv-product")));
    const {slug} = useParams();
    const [page,setPage] = useState(0);
    const [Comments, setComments] = useState([]);
    const [userProducts,setUserProducts] = useState([]);
    const [recProducts,setRecProducts] = useState([]);
    const [ymlProducts,setYmlProducts] = useState([]);
    const [listCollection,setListCollection] = useState([]);
    const [metaColors,setMetaColors] = useState("");



    const [shareActive, setShareActive] = useState(0);
    const [sharepath, setSharePath] = useState('');
    const openShare = (e)=>{
      setSharePath(e);
      setShareActive(1);
    }



    const [productDetail, setProductDetails] = useState({
        id :0,
        title:"",
        discription:"",
        price :0,
        compareatprice :0,
        brand :"",
        condition:"",
        listing:"",
        sold:0,
        intrusts:[],
        images :[],
        likes :0,
        comments :0,
        sizes : "",
        colors : [],
        sizelist: [],
        username: "",
        likethis:false,
        bookmarkthis:false,
        listingvarients:[],
        hasvarients:false,
        deliverytype:1,
        counter:0
    });
    const [userDetail, setuserDetails] = useState({
        id : 0,
        activetoday : true,
        username : "",
        discription : "",
        firstname : "",
        lastname : "",
        followers : 0,
        following : 0,
        averagestars : 3,
        reviewcount : 100,
        image : "",
        followingthis : false,
        soldcount : 0,
        role: 'individual'
    });
    const Refresh = ()=>{
      let usercall = 0;
      if(User){
        usercall = User.id
      }
      fetch(ApiUrl.API_URL_Listing+"/"+usercall+"/"+slug)
      .then(res=>res.json())
      .then(data =>{
          setProductDetails(data);
          fetch(ApiUrl.API_URL_ListingRecommend+"/"+data.id)
          .then(res2=>res2.json())
          .then(data2 =>{
              setRecProducts(data2.responce);
          })
      })
    }
    const UserRefresh = ()=>{
      fetch(ApiUrl.API_URL_Profile+"/"+User.id+"/"+productDetail.username)
      .then(res=>res.json())
      .then(data =>{
          if(data.success){
              setuserDetails(data.responce);
          }
      });
    }
    const change_like = ()=>{
        fetch(ApiUrl.API_URL_Like, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
              listingid : productDetail.id
            })
          })
          .then(res=>res.json())
          .then(data =>{
            Refresh();
        });
    }
    const RefreshBookmark = ()=>{
      let usercall = 0;
      if(User){
        usercall = User.id
      }
      fetch(ApiUrl.API_URL_Listing+"/"+usercall+"/"+slug)
      .then(res=>res.json())
      .then(data =>{
          console.log(data);
          setProductDetails(data);
      })
    }
    const change_bookmark = ()=>{
        fetch(ApiUrl.API_URL_Bookmark, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
              productid : productDetail.id
            })
          })
          .then(res=>res.json())
          .then(data =>{
            RefreshBookmark();
        });
    }
    const showPopUp = () =>{
        popupBox.current.className = 'active top_settings_popup';
        setTimeout(() => {
            popupBoxContainer.current.className = 'active top_settings_popup_container';
        }, 20);
    }
    const hidePopUp = () =>{
        popupBox.current.className = 'top_settings_popup'
        popupBoxContainer.current.className = 'top_settings_popup_container'
    }
    useEffect(()=>{
        let usercall = 0;
        if(User){
          usercall = User.id
        }
        fetch(ApiUrl.API_URL_Listing+"/"+usercall+"/"+slug)
        .then(res=>res.json())
        .then(data =>{
            console.log(data);
            setProductDetails(data);
            fetch(ApiUrl.API_URL_ListingRecommend+"/"+data.id)
            .then(res2=>res2.json())
            .then(data2 =>{
                setRecProducts(data2.responce);
            })

            fetch(ApiUrl.API_URL_ListCollectionListing+"/"+data.id)
            .then(res2=>res2.json())
            .then(data2 =>{
              setListCollection(data2.responce);
            })


            fetch(ApiUrl.API_URL_Comments+"/"+data.id)
            .then(res=>res.json())
            .then(data =>{
              setComments(data);
            })
            let newrcproduct = [];
            if(JSON.parse(localStorage.getItem("rcnsv-product"))){
              newrcproduct = JSON.parse(localStorage.getItem("rcnsv-product"));
            }
            var newrcproductsend = [];
            for (let index = 0; index < newrcproduct.length; index++) {
              const element = newrcproduct[index];
              if(element.id !== data.id){
                newrcproductsend.push(element);
              }
            }
            newrcproductsend.push({
              id : data.id,
              title : data.title,
              compareatprice : data.compareatprice,
              price : data.price,
              slug : slug,
              state : data.state,
              image: data.images[0],
              sold: data.sold
            });
            localStorage.setItem("rcnsv-product",JSON.stringify(newrcproductsend));
            setRcProduct(newrcproductsend);
            fetch(ApiUrl.API_URL_Profile+"/"+usercall+"/"+data.username)
            .then(res=>res.json())
            .then(data =>{
                if(data.success){
                    setuserDetails(data.responce);
                }
            });
        });
        fetch(ApiUrl.API_URL_ListingState+"/0")
        .then(res=>res.json())
        .then(data =>{
            if(data.success)
            setYmlProducts(data.responce.data2);
        });

        fetch(ApiUrl.API_URL_Comments+"/"+productDetail.id)
        .then(res=>res.json())
        .then(data =>{
          setComments(data);
        });
    },[slug])
    useEffect(()=>{
      if(userDetail.username !== ''){
        fetch(ApiUrl.API_URL_ListingUser+"/"+userDetail.username)
        .then(res=>res.json())
        .then(data =>{
            if(data.success)
            setUserProducts(data.responce);
        });
      }
    },[userDetail.username])


    const [selectedvarient,setSelectedVarient] = useState({
      id :0,
      productid :0,
      title :"",
      sku :"",
      price :0,
      compareatprice :0,
      deliverytype :1,
      count :0,
      size :0,
      color :0
    });
    const [selectedsize,setSelectedSize] = useState({
      id:0,
      name:"",
      qty:0
    });
    const [selectedcolor,setSelectedColor] = useState({
      id:0,
      code:""
    });

    useEffect(()=>{
      if(!productDetail.hasvarients){
        return;
      }
      setSelectedColor(productDetail.colors[0])
      setSelectedSize(productDetail.sizelist[0])
      var metacolors = "";
      for (let index = 0; index < productDetail.colors.length; index++) {
        const element = productDetail.colors[index];
        metacolors = metacolors + element.name;
        if((index+1) < productDetail.colors.length){
          metacolors = metacolors + " -"
        }
      }
      setMetaColors(metacolors);
    },[productDetail])

    useEffect(()=>{
      if(!productDetail.hasvarients){
        return;
      }
      for (let index = 0; index < productDetail.listingvarients.length; index++) {
        const element = productDetail.listingvarients[index];
        if(String(element.size) === String(selectedsize.id) && String(element.color) === String(selectedcolor.id)){
          setSelectedVarient(element);
        }
      }
    },[selectedsize,selectedcolor])

    const addtobag = ()=>{
      if(userDetail.id === 0){
        alert('Please wait page is loading');
      }
      if(productDetail.hasvarients){
        if(selectedvarient.count < 1){
          alert('Out of stock');
          return;
        }
      }
      else{
        if(productDetail.counter < 1){
          alert('Out of stock');
          return;
        }
      }
      if(productDetail.sold !== 0){
        alert('Out of stock');
        return;
      }
      var newbag = [];
      if(Bag){
        newbag = Bag;
      }
      newbag.push({
        productid : productDetail.id,
        varinetid : (productDetail.hasvarients? parseInt(selectedvarient.id) : 0),
        hasvarients : productDetail.hasvarients,
        size : (productDetail.hasvarients? parseInt(selectedsize.id) : 0),
        sizeName : (productDetail.hasvarients? selectedsize.name : ""),
        color : (productDetail.hasvarients? parseInt(selectedcolor.id) : 0),
        colorcode : (productDetail.hasvarients? selectedcolor.code : ""),
        price: (productDetail.hasvarients? selectedvarient.price:productDetail.price),
        image: (productDetail.images[0]),
        title: productDetail.title,
        slug: slug,
        sellerid: userDetail.id
      })
      localStorage.setItem("product-cart",JSON.stringify(newbag));
      document.location.reload();
    }

    const addChatBox = ()=>{
      var newchatboxes = [];
      var exist = false;
      if(ChatBoxes){
        for (let index = 0; index < ChatBoxes.length; index++) {
          const element = ChatBoxes[index];
          newchatboxes.push(element)
          if(element.userid == userDetail.id){
            setOpenChatBox(element);
            exist = true;
          }
        }
      }
      if(!exist){
        ChatFunctions.CreateRoom(userDetail.id,(id)=>{
          newchatboxes.push({
            id:id,
            userid:userDetail.id,
            userimage:userDetail.image,
            username:userDetail.username,
            first:userDetail.firstname,
            last:userDetail.lastname,
            isUserA:true
          })
          localStorage.setItem("chat-boxes",JSON.stringify(newchatboxes));
          setOpenChatBox({
            id:id,
            userid:userDetail.id,
            userimage:userDetail.image,
            username:userDetail.username,
            first:userDetail.firstname,
            last:userDetail.lastname,
            isUserA:true
          });
        })
      }
    }
    const meta = {
      title: 'Shop '+productDetail.title+' online at KAAY',
      description: `Buy ${productDetail.title} from ${productDetail.brand.name} online at KAAY. Our ${productDetail.title} is designed according to the latest trends and is made from high quality materials. Its available in ${metaColors} color. Shop from KAAY with the lowest available shipping charges in Pakistan.`,
      canonical:  window.location.href
      /*meta: {
          charset: 'utf-8',
          name: {
              keywords: 'react,meta,document,html,tags'
          }
      }*/
    }
  return (
    <>
    
      <DocumentMeta {...meta} />
    <main>
      <div className='product_wrapper'>
        <div className='product_container'>
          <div className='product_images_wrapper'>
            <div className='product_images'>
              <Images Value = {productDetail.images}/>
            </div>
            {recProducts.length !== 0 &&
              <div className='public_home_explore_container'>
                  <div className='public_home_explore_b2c'>
                    <ProductGrid7 
                      Title={'Recommended by seller'}
                      Discription={''}
                      To={''}
                      Products={recProducts}
                      Columns={15}
                    />
                  </div>
              </div>
            }
          </div>
          <div className='product_dis_wrapper'>
            <div className='product_dis_container'>
              <ProductUser Refresh={UserRefresh} userDetail = {userDetail}/>
              <div className='product_title'>
                <h1>{productDetail.title}</h1>
              </div>
              <div className='product_user_icons'>
                  {productDetail.bookmarkthis === false &&
                    <BookmarkIcon width="20px" height="40px" onClick={change_bookmark}/>
                  }
                  {productDetail.bookmarkthis === true &&
                    <BookmarkFillIcon width="20px" height="40px" onClick={change_bookmark}/>
                  }
                  {productDetail.likethis === false &&
                    <LikeIcon width="20px" height="40px" onClick={change_like} />
                  }
                  {productDetail.likethis === true &&
                    <LikeFillIcon width="20px" height="40px" onClick={change_like} />
                  }
                  <MessageChatIcon width="20px" height="40px" onClick={addChatBox}/>
                  <ShareIcon width="20px" height="40px"  onClick={()=>{openShare("product/"+slug)}} />
              </div>
              <div className='product_user_likecount'>
                <p><b>{productDetail.likes}</b>Like  <b>{Comments.length}</b>Comments</p>
              </div>
              {productDetail.hasvarients &&
              <div className='varient_selector'>
                <div className='product_sizelist'>
                  <h3>Sizes</h3>
                  <div className='product_sizelist_items'>
                  {
                    productDetail.sizelist.map((size,index)=>{
                      return(
                        <div key={index} className={String(size.id) === String(selectedsize.id)?'product_sizelist_item active':'product_sizelist_item'}>
                          <button onClick={()=>{setSelectedSize(size)}}>{size.name}</button>
                        </div>
                      )
                    })
                  }
                  </div>
                </div>
                <div className='product_colorlist'>
                  <h3>Colors</h3>
                  <div className='product_colorlist_items'>
                  {
                      productDetail.colors.map((color,index)=>{
                          return(
                          <div key={index} className={String(color.id) === String(selectedcolor.id)?  'product_colorlist_item active':'product_colorlist_item'}>
                              <button onClick={()=>{setSelectedColor(color)}} style={{backgroundColor:color.code}}></button>
                          </div>
                          )
                      })
                  }
                  </div>
                </div>
              </div>
              }

              <div className='product_stickarea'>
                <div className='product_priceNdiscount'>
                  <div className='product_price'>
                    {productDetail.hasvarients &&
                      <p>
                        {selectedvarient.compareatprice !== 0 && selectedvarient.compareatprice > selectedvarient.price && selectedvarient.compareatprice !== undefined &&
                            <b>Rs.{selectedvarient.compareatprice}/-</b>
                        }
                        Rs.{
                        selectedvarient.price
                    }/-</p>
                    }
                    {!productDetail.hasvarients &&
                      <p>
                        {productDetail.compareatprice !== 0 && productDetail.compareatprice > productDetail.price && productDetail.compareatprice !== undefined &&
                          <b>Rs.{productDetail.compareatprice}/-</b>
                        }
                        Rs.{productDetail.price}/-</p>
                    }
                  </div>
                  {productDetail.hasvarients && selectedvarient.compareatprice !== 0 && selectedvarient.compareatprice > selectedvarient.price && selectedvarient.compareatprice !== undefined &&
                    <div className='product_discount' style={{backgroundImage:`url(${DiscountIcon})`}}>
                      <p>{100-Math.round((selectedvarient.price/selectedvarient.compareatprice)*100)}%</p>
                    </div>
                  }
                  {!productDetail.hasvarients && productDetail.compareatprice !== 0 && productDetail.compareatprice > productDetail.price && productDetail.compareatprice !== undefined &&
                    <div className='product_discount' style={{backgroundImage:`url(${DiscountIcon})`}}>
                      <p>{100-Math.round((productDetail.price/productDetail.compareatprice)*100)}%</p>
                    </div>
                  }
                </div>
                <div className='product_buynow'>
                  <Button  Value="Buy now" Action={addtobag}/>
                </div>
                {/*userDetail.role === 'individual' &&
                  <div className='product_buynow'>
                    <Button  Value="Make an offer" Action={showPopUp}/>
                  </div>
                */}
                <div className='product_delivery_time'>
                  {productDetail.sold === 0 &&
                    <>
                      {!productDetail.hasvarients &&
                        <p>
                          {productDetail.deliverytype === 1 && productDetail.counter === 0 &&
                          "Out of stock"
                          }
                          {productDetail.deliverytype === 1 && productDetail.counter > 0 &&
                          "Available in stock"
                          }
                          {productDetail.deliverytype === 2 &&
                          String(productDetail.counter)+" Days for production"
                          }
                          {productDetail.deliverytype === 3 &&
                          String(productDetail.counter)+" Months for production"
                          }
                        </p>
                      }
                      {productDetail.hasvarients &&
                        <p>
                          {selectedvarient.deliverytype === 1 && selectedvarient.count === 0 &&
                          "Out of stock"
                          }
                          {selectedvarient.deliverytype === 1 && selectedvarient.count > 0 &&
                          "Available in stock"
                          }
                          {selectedvarient.deliverytype === 2 &&
                          String(selectedvarient.count)+" Days for production"
                          }
                          {selectedvarient.deliverytype === 3 &&
                          String(selectedvarient.count)+" Months for production"
                          }
                        </p>
                      }
                    </>
                  }
                  {productDetail.sold !== 0 &&
                    <p>
                      Out of stock
                    </p>
                  }
                </div>
                <div className='public_home_pagesswitch_container'>
                    <div className={page === 0?'public_home_exploretab_container active':'public_home_exploretab_container'} onClick={
                        ()=>{setPage(0);}
                    }>
                        <h5>About</h5>
                    </div>
                    <div className={page === 1?'public_home_feedtab_container active':'public_home_feedtab_container'} onClick={
                        ()=>{setPage(1);}
                    }>
                        <h5>Comments</h5>
                    </div>
                </div>
              </div>
              {page === 0 &&
                <>
                  <div className='product_discription'>
                    <p>{productDetail.discription}</p>
                    <div className='product_hashtag_container'>
                      {
                        productDetail.intrusts.map((item,index)=>{
                          return(
                            <Link to={'/hashtag/'+item.name} key={index}><b style={{cursor:"pointer", padding:"0px 5px"}}>{"#"+item.name}</b></Link>
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className='product_varient_slab'>
                    <div className='product_varient_slab_title'>
                      <p>Price</p>
                    </div>
                    <div className='product_varient_slab_dis'>
                      <p>Rs. {productDetail.price}/-</p>
                    </div>
                  </div>
                  <div className='product_varient_slab'>
                    <div className='product_varient_slab_title'>
                      <p>Size</p>
                    </div>
                    <div className='product_varient_slab_dis'>
                      <p>{productDetail.sizes}</p>
                    </div>
                  </div>
                  <div className='product_varient_slab'>
                    <div className='product_varient_slab_title'>
                      <p>Brand</p>
                    </div>
                    <div className='product_varient_slab_dis'>
                      <Link to={'/filter?brand='+productDetail.brand.id}>
                        <h6>{productDetail.brand.name}</h6>
                      </Link>
                    </div>
                  </div>
                  <div className='product_varient_slab'>
                    <div className='product_varient_slab_title'>
                      <p>Condition</p>
                    </div>
                    <div className='product_varient_slab_dis'>
                      <Link to={'/filter?condition='+productDetail.condition.id}>
                        <h6>{productDetail.condition.name}</h6>
                      </Link>
                    </div>
                  </div>
                  <div className='product_varient_slab'>
                    <div className='product_varient_slab_title'>
                      <p>Collections</p>
                    </div>
                    <div className='product_varient_slab_dis'>
                      <div className='product_hashtag_container' style={{
                        justifyContent:"flex-end"
                      }}>
                        {
                          listCollection.map((item,index)=>{
                            return(
                              <Link to={'/ncollection/'+item.id} key={index}><b style={{cursor:"pointer", padding:"0px 5px"}}>{item.name}</b></Link>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                  <div className='product_varient_slab'>
                    <div className='product_varient_slab_title'>
                      <p>Color</p>
                    </div>
                    <div className='product_varient_slab_dis'>
                      <div style={{display:"flex", justifyContent:"flex-end"}}>
                        {
                          productDetail.colors.map((item,index)=>{
                            return(
                              <Link to={'/filter?color='+item.id} key={index}>
                                <div style={{height:"20px", width:"20px",backgroundColor:item.code}}>

                                </div>
                              </Link>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                  <div className='product_listing'>
                    <p>LISTED {productDetail.listing}</p>
                  </div>
                </>
              }
              {page === 1 &&
                <>
                  <CommentBox productID={productDetail.id} comments={Comments} setComments={setComments} />
                </>
              }
            </div>
          </div>
        </div>
      </div>
      <div className='public_home_explore_container'>
        <div className='public_home_explore_b2c'>
          <ProductGrid7 
            Title={'More From Seller'}
            Discription={''}
            To={'/user/'+userDetail.username}
            Products={userProducts}
            Columns={15}
          />
        </div>
      </div>
      <div className='public_home_explore_container'>
        <div className='public_home_explore_b2c'>
          <ProductGrid7 
            Title={'You May Also Like'}
            Discription={''}
            To={''}
            Products={ymlProducts}
            Columns={15}
          />
        </div>
      </div>
      {rcProduct &&
        <div className='public_home_explore_container'>
          <div className='public_home_explore_b2c'>
            <ProductGrid8 
              Title={'Recently Viewed'}
              Discription={''}
              To={''}
              Products={rcProduct}
              Columns={15}
            />
          </div>
        </div>
      }

      <div className='top_settings_popup' ref={popupBox}>
          <div className='top_settings_popup_container' ref={popupBoxContainer}>
            <div style={{
              padding:"200px 20px"
            }}>
              <h5 style={{textAlign:"center"}}>We are onboarding</h5>
            </div>
          </div>
          <div className='top_settings_popup_closer' onClick={hidePopUp}></div>
      </div>
      <SharePopup Active={shareActive} SetActive={setShareActive} Path={sharepath}/>
    </main>
    </>
    
  )
}

export default Index
